<template>
  <div>
    <div id="container">
      <div id="ban">
        <ul id="banner">
            <li>
              <div class="text">
                <div>
                  <img src="../../../../static/img/promotion/reviews_user5.png" alt="">
                  <div>
                    <span>{{$t('reviews_user5')}}</span>
                    <div class="reviews-star">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                    </div>
                  </div>
                </div>
                <span>{{$t('reviews_con5')}}</span>
                <span class="date">{{$t('reviews_data5')}}</span>
              </div>
            </li>
            <li>
              <div class="text">
                <div>
                  <img src="../../../../static/img/promotion/reviews_user1.png" alt="">
                  <div>
                    <span>{{$t('reviews_user1')}}</span>
                    <div class="reviews-star">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                    </div>
                  </div>
                </div>
                <span>{{$t('reviews_con1')}}</span>
                <span class="date">{{$t('reviews_data1')}}</span>
              </div>
            </li>
            <li>
              <div class="text">
                <div>
                  <img src="../../../../static/img/promotion/reviews_user2.png" alt="">
                  <div>
                    <span>{{$t('reviews_user2')}}</span>
                    <div class="reviews-star">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                    </div>
                  </div>
                </div>
                <span>{{$t('reviews_con2')}}</span>
                <span class="date">{{$t('reviews_data2')}}</span>
              </div>
            </li>
            <li>
              <div class="text">
                <div>
                  <img src="../../../../static/img/promotion/reviews_user3.png" alt="">
                  <div>
                    <span>{{$t('reviews_user3')}}</span>
                    <div class="reviews-star">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                    </div>
                  </div>
                </div>
                <span>{{$t('reviews_con3')}}</span>
                <span class="date">{{$t('reviews_data3')}}</span>
              </div>
            </li>
            <li>
              <div class="text">
                <div>
                  <img src="../../../../static/img/promotion/reviews_user4.png" alt="">
                  <div>
                    <span>{{$t('reviews_user4')}}</span>
                    <div class="reviews-star">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                    </div>
                  </div>
                </div>
                <span>{{$t('reviews_con4')}}</span>
                <span class="date">{{$t('reviews_data4')}}</span>
              </div>
            </li>
            <li>
              <div class="text">
                <div>
                  <img src="../../../../static/img/promotion/reviews_user5.png" alt="">
                  <div>
                    <span>{{$t('reviews_user5')}}</span>
                    <div class="reviews-star">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                    </div>
                  </div>
                </div>
                <span>{{$t('reviews_con5')}}</span>
                <span class="date">{{$t('reviews_data5')}}</span>
              </div>
            </li>
            <li>
              <div class="text">
                <div>
                  <img src="../../../../static/img/promotion/reviews_user1.png" alt="">
                  <div>
                    <span>{{$t('reviews_user1')}}</span>
                    <div class="reviews-star">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                      <img src="../../../../static/img/promotion/netflix-review-star.png" alt="">
                    </div>
                  </div>
                </div>
                <span>{{$t('reviews_con1')}}</span>
                <span class="date">{{$t('reviews_data1')}}</span>
              </div>
            </li>
        </ul>
      </div>

    </div>
      <a href="javascript:;" id="prev" class="arrow">
        <img src="../../../../static/img/promotion/netflix-arrow.png" alt="">
      </a>  
      <a href="javascript:;" id="next" class="arrow">
        <img src="../../../../static/img/promotion/netflix-arrow.png" alt="">
      </a>  
  </div>
</template>

<script>
import { load } from './ReviewText.js'
import locales from './lang'

export default {
  locales,
  methods: {
  },
  mounted() {
    load()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import '../../../assets/scss/common.scss';
  #container {
    position: relative;
    margin: 0 20px;
  }
  #ban {
    width: 100%;
    height: 220px;
    overflow: hidden;
  }
  #banner,
  #banner li{
      list-style: none;
      margin: 0;
      padding: 0;
  }
  #banner{
      position: absolute;
      li {
        float: left;
      }
      li>.text {
        display: block;
        height: 210px;
        width: 400px;
        padding : 30px 30px 0;
        text-align: left;
        border: 1px solid #CCCCCC;
        background-color: #FFFFFF;
        position: relative;
        span {
          display: block;
          text-align: left;
        }
        .date{
          position: absolute;
          right: 10px;
          bottom: 15px;
          font-size: 12px;
        }
        >div {
          display: flex;
          align-items: center;
          img {
            display: inline-block;
            height: 48px;
            width: 48px;
            margin-right: 20px;
          }
          div {
            display: inline-block;
            .reviews-star {
              display: flex;
              height: 18px;
              font-size: 14px;
              font-weight: 400;
              letter-spacing: 0;
              line-height: 18px;
              text-align: center;
              color: #999999;
              opacity: 0.8;
              img {
                display: block;
                height: 16px;
                width: 16px;
                margin-right: 6px;
              }
            }
          }
          span:nth-child(1) {
            margin-bottom: 8px;
            font-size: 18px;
            font-weight: 900;
            letter-spacing: 0;
            line-height: 22px;
            color: #666666;
          }
        }
        >span {
          margin-top: 22px;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 0;
          line-height: 22px;
          color: #999999;
          opacity: 0.8;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      li~li>div {
        margin-left: 30px;
      }
  }

  .arrow{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 70px;
      height: 70px;
      position: absolute;
      z-index: 1;
      top: 50%;
      transform: translateY(-50%);
      border: 1px solid #FFFFFF;
      border-radius: 50%;
      color: #fff;
      cursor: pointer;
      span {
        display: inline-block;
        height: 16px;
        width: 16px;
        transform: rotate(45deg);
      }
  }
  #prev{
      left: -70px;
      img{
        transform: rotate(180deg);
      }
  }
  #next{
      right: -70px;
  }
  @media screen and (max-width: 1400px) {
    #prev{
        left: 50px;
        img{
          transform: rotate(180deg);
        }
    }
    #next{
        right: 50px;
    }
  }
  @media screen and (max-width: 768px) {
    #container {
      margin: 0 pxs2rem(20);
    }
    #ban {
      height: px2rem(220);
    }
    #banner {
      li~li>div {
        margin-left: px2rem(8);
      }
      li {
        >.text {
          height: px2rem(220);
          width: px2rem(325);
          padding: px2rem(30) px2rem(15) 0;
          >span {
            margin-top: px2rem(7);
            font-size: px2rem(16);
            line-height: px2rem(22);
          }
          >div {
            img {
              height: px2rem(48);
              width: px2rem(48);
              margin-right: pxs2rem(20);
            }
            div {
              .reviews-star {
                height: px2rem(18);
                font-size: px2rem(14);
                line-height: px2rem(18);
                img {
                  height: px2rem(16);
                  width: px2rem(16);
                  margin-right: px2rem(6);
                }
              }
            }
            span:nth-child(1) {
              margin-bottom: px2rem(8);
              font-size: px2rem(18);
              line-height: px2rem(22);
            }
          }
        }
      }
    }
    .arrow {
      width: px2rem(55);
      height: px2rem(55);
      span {
        height: px2rem(10);
        width: px2rem(10);
      }
    }
    #prev {
      left: px2rem(10);
    }
    #next{
      right: px2rem(10);
    }
  }

</style>


// WEBPACK FOOTER //
// ReviewText.vue?4164423c